import { dashboardData } from "./dashboardData";

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const dashboardService = {
  getDashboardData: async (_userId, selectedMonth = "Feb 2024") => {
    await delay(700);

    return {
      data: {
        ...dashboardData,
        selectedMonth,
      },
      status: 200,
    };
  },

  getDashboardMetrics: async _userId => {
    await delay(400);

    return {
      data: dashboardData.metrics,
      status: 200,
    };
  },

  getOccupancyChartData: async (_userId, period = "daily") => {
    await delay(500);

    let chartData;
    switch (period.toLowerCase()) {
      case "weekly":
        chartData = dashboardData.occupancyChart.weekly;
        break;
      case "monthly":
        chartData = dashboardData.occupancyChart.monthly;
        break;
      case "daily":
      default:
        chartData = dashboardData.occupancyChart.daily;
    }

    return {
      data: chartData,
      period,
      status: 200,
    };
  },

  getRevenueChartData: async _userId => {
    await delay(500);

    return {
      data: dashboardData.revenueChart.data,
      status: 200,
    };
  },

  getTodaysBookings: async _userId => {
    await delay(600);

    return {
      data: dashboardData.todaysBookings,
      status: 200,
    };
  },

  getQuickActions: async _userId => {
    await delay(300);

    return {
      data: dashboardData.quickActions,
      status: 200,
    };
  },

  getAvailableMonths: async _userId => {
    await delay(200);

    return {
      data: dashboardData.availableMonths,
      status: 200,
    };
  },

  getNotificationCount: async _userId => {
    await delay(300);

    return {
      data: dashboardData.notificationCount,
      status: 200,
    };
  },

  markNotificationsAsRead: async userId => {
    await delay(500);

    return {
      data: {
        notificationCount: 0,
        message: "Notifications marked as read",
        updatedBy: userId,
        updatedAt: new Date().toISOString(),
      },
      status: 200,
    };
  },

  executeQuickAction: async (userId, actionId) => {
    await delay(400);

    return {
      data: {
        actionId,
        message: "Quick action executed successfully",
        executedBy: userId,
        executedAt: new Date().toISOString(),
      },
      status: 200,
    };
  },

  updateDashboardPreferences: async (userId, preferences) => {
    await delay(500);

    return {
      data: {
        preferences,
        updatedBy: userId,
        updatedAt: new Date().toISOString(),
      },
      status: 200,
    };
  },
};
